import { render, staticRenderFns } from "./akm.vue?vue&type=template&id=57821fa6&"
import script from "./akm.vue?vue&type=script&lang=js&"
export * from "./akm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports